export default {
      id: "arrow-down-transparent-usage",
      viewBox: "0 0 8 5",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#arrow-down-transparent",
      toString: function () {
        return this.url;
      }
    }